/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { webhooksUpdate } from "../../funcs/webhooksUpdate.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.UpdateWebhookRequest$inboundSchema,
};

export const tool$webhooksUpdate: ToolDefinition<typeof args> = {
  name: "webhooks-update",
  description: `Update an existing webhook.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await webhooksUpdate(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value.result;

    return formatResult(value, apiCall);
  },
};
